module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('transition', {
    attrs: {
      "name": "fadeinplace"
    }
  }, [(_vm.page) ? _c('page-body', {
    attrs: {
      "title": _vm.text(_vm.page, 'page.title'),
      "body": _vm.html(_vm.page, 'page.body'),
      "footHead": _vm.slug === 'contact' ? false : 'Contact',
      "footBody": _vm.html(_vm.site, 'site.contact_details'),
      "showCredits": _vm.slug === 'info',
      "fontStyle": _vm.fontStyle
    }
  }, [(_vm.showEnquireBtn) ? _c('div', [_c('a', {
    attrs: {
      "href": ("mailto:" + _vm.email),
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('enquire-btn', [_vm._v("Enquries")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showNewsletterForm) ? _c('subscribe-form', {
    staticClass: "is-hidden-mobile",
    attrs: {
      "mailchimpNewsletterID": _vm.mailchimpNewsletterID
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.pageNotFound) ? _c('article', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('appfooter', {
    attrs: {
      "site": _vm.site
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Page Not Found")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b5fda5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = 392
// module chunks = 1